export const getRandomInteger = (min = 100, max = 100000) => {
  const newMin = Math.ceil(min)
  const newMax = Math.floor(max)
  return Math.floor(Math.random() * (newMax - newMin + 1)) + newMin
}
